export const TAG_NAME_MAX_LENGTH = 50
export const TAG_DESC_MAX_LENGTH = 100
export const MAX_TAGS_PER_TASK = 10

export const TAG_COLORS = new Map([
  ['red-normal', { color: '#FFFFFF', bg_color: '#FF2525' }],
  ['red-medium', { color: '#FFFFFF', bg_color: '#FF6C6C' }],
  ['red-light', { color: '#3C3C3C', bg_color: '#FFA3A3' }],
  ['red-extra-light', { color: '#3C3C3C', bg_color: '#FFD0D0' }],

  ['blue-normal', { color: '#FFFFFF', bg_color: '#2572FF' }],
  ['blue-medium', { color: '#FFFFFF', bg_color: '#6C93FF' }],
  ['blue-light', { color: '#3C3C3C', bg_color: '#A3C3FF' }],
  ['blue-extra-light', { color: '#3C3C3C', bg_color: '#D0E8FF' }],

  ['green-normal', { color: '#FFFFFF', bg_color: '#00A63D' }],
  ['green-medium', { color: '#FFFFFF', bg_color: '#60C55A' }],
  ['green-light', { color: '#3C3C3C', bg_color: '#85DA57' }],
  ['green-extra-light', { color: '#3C3C3C', bg_color: '#A6E796' }],

  ['orange-normal', { color: '#FFFFFF', bg_color: '#FF9925' }],
  ['orange-medium', { color: '#FFFFFF', bg_color: '#FFAC6C' }],
  ['orange-light', { color: '#3C3C3C', bg_color: '#FFD3A3' }],
  ['orange-extra-light', { color: '#3C3C3C', bg_color: '#FFEBD0' }],

  ['purple-normal', { color: '#FFFFFF', bg_color: '#AD40DB' }],
  ['purple-medium', { color: '#FFFFFF', bg_color: '#E77CFF' }],
  ['purple-light', { color: '#3C3C3C', bg_color: '#F0A3FF' }],
  ['purple-extra-light', { color: '#3C3C3C', bg_color: '#FDD0FF' }],

  ['yellow-normal', { color: '#3C3C3C', bg_color: '#FFE625' }],
  ['yellow-medium', { color: '#3C3C3C', bg_color: '#FFDF6C' }],
  ['yellow-light', { color: '#3C3C3C', bg_color: '#FFEEA3' }],
  ['yellow-extra-light', { color: '#3C3C3C', bg_color: '#FFF8D0' }],

  ['violet-normal', { color: '#FFFFFF', bg_color: '#8A6AEA' }],
  ['violet-medium', { color: '#FFFFFF', bg_color: '#B49BFF' }],
  ['violet-light', { color: '#000000', bg_color: '#D5C7FF' }],
  ['violet-extra-light', { color: '#000000', bg_color: '#E9E2FF' }],

  ['gray-normal', { color: '#FFFFFF', bg_color: '#3C3C3C' }],
  ['gray-medium', { color: '#FFFFFF', bg_color: '#636363' }],
  ['gray-light', { color: '#000000', bg_color: '#909090' }],
  ['gray-extra-light', { color: '#000000', bg_color: '#B5B5B5' }],
])
